import React from 'react';
import './howToPlay.style.css';
import SEO from '../../SEO';

const HowToPlay: React.FC = () => {
    return (
        <>
            <SEO 
                title="How to Play Wild Chips Poker - Texas Hold'em Rules Guide"
                description="Learn how to play Texas Hold'em Poker in Wild Chips. Master the rules, hand rankings, and game flow with our comprehensive guide to jungle-themed poker."
                keywords="how to play poker, texas holdem rules, poker hand rankings, poker game guide, poker strategy, wild chips poker rules"
                ogImage="/images/bgHowToPlay-min.png"
                canonicalUrl="https://wildchipspoker.com/how-to-play"
            />
            <div className="all-pages-padding howToPlay-container">
                <div className="howToPlay-game-description">
                    <h2>Texas Hold'em Poker Rules</h2>
                    <p>
                        Welcome to Texas Hold'em Poker! This popular variant of poker combines strategy, 
                        skill, and a bit of luck to create an exciting card game experience.
                    </p>
                    <h3>Basic Rules:</h3>
                    <ul>
                        <li>Each player is dealt 2 private cards (hole cards)</li>
                        <li>5 community cards are dealt face-up on the table</li>
                        <li>Players must make the best 5-card hand using any combination of their hole cards and community cards</li>
                    </ul>

                    <h3>Game Flow:</h3>
                    <ol>
                        <li><strong>Pre-Flop:</strong> Players receive their hole cards and place initial bets</li>
                        <li><strong>Flop:</strong> First 3 community cards are dealt</li>
                        <li><strong>Turn:</strong> Fourth community card is dealt</li>
                        <li><strong>River:</strong> Final community card is dealt</li>
                        <li><strong>Showdown:</strong> Players reveal their hands and the best hand wins</li>
                    </ol>

                    <h3>Hand Rankings (from highest to lowest):</h3>
                    <ul>
                        <li>Royal Flush: A, K, Q, J, 10 of the same suit</li>
                        <li>Straight Flush: Five consecutive cards of the same suit</li>
                        <li>Four of a Kind: Four cards of the same rank</li>
                        <li>Full House: Three of a kind plus a pair</li>
                        <li>Flush: Five cards of the same suit</li>
                        <li>Straight: Five consecutive cards</li>
                        <li>Three of a Kind: Three cards of the same rank</li>
                        <li>Two Pair: Two different pairs</li>
                        <li>One Pair: Two cards of the same rank</li>
                        <li>High Card: Highest card when no other hand is made</li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default HowToPlay;

